var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from 'vue';
import { Component, Watch } from "vue-property-decorator";
import axios from "axios";
let FormatList = class FormatList extends Vue {
    search = '';
    item = {
        id: 0,
        name: ""
    };
    filter = [];
    cardBtn = "";
    cardTitel = "";
    Format = [];
    name = "";
    loading = false;
    dia = false;
    page = {
        total: 0
    };
    options = {
        itemsPerPage: 20,
        page: 1,
        total: 0
    };
    text = '';
    snackbar = false;
    timeout = -1;
    color = "";
    headers = [
        { text: 'Format', align: 'start', value: 'format' },
        { text: 'Aktionen', value: 'actions' },
    ];
    openCreateDia() {
        this.cardTitel = "Format erstellen";
        this.cardBtn = "Format erstellen";
        this.dia = true;
    }
    openEditDia(item) {
        this.item = item;
        this.name = item.format;
        this.cardTitel = "Format bearbeiten";
        this.cardBtn = "Format ändern";
        this.dia = true;
    }
    getFromatList() {
        this.loading = true;
        this.setFilter('search', this.search);
        axios.get('/api/format', {
            params: {
                itemsPerPage: this.options.itemsPerPage,
                page: this.options.page,
                sortBy: this.options.sortBy.toString(),
                sortDesc: this.options.sortDesc,
                filter: this.filter,
            }
        }).then((response) => {
            this.Format = response.data.data;
            this.page = response.data.meta;
            this.loading = false;
        });
        return this.Format;
    }
    async edit() {
        this.item.name = this.name;
        await axios.put('/api/format/' + this.item.id, { format: this.item }).then((response) => {
            this.name = "";
            this.color = "green";
            this.text = "Die Dicke wurde erfolgreich geändert oder angelegt";
            this.snackbar = true;
        }).catch((error) => {
            this.color = "red";
            this.text = "Die Dicke wurde nicht erfolgreich geändert oder angelegt";
            this.snackbar = true;
        });
        this.clear();
    }
    clear() {
        this.item = {
            id: 0,
            name: ""
        };
        this.name = "";
        this.dia = false;
        this.snackbar = false;
    }
    async Delete(item) {
        if (confirm("Möchtest du wirklich das Format löschen?")) {
            await axios.delete('/api/format/' + item.id).then((response) => {
                this.color = "green";
                this.text = "die Dicke wurde erfolgreich gelöscht";
                this.snackbar = true;
            }).catch((error) => {
                this.color = "red";
                this.text = "das Format wird in einem Auftrag verwendet. " +
                    "Deswegen kann dieses Format nicht gelöscht werden";
                this.snackbar = true;
            });
        }
        this.getFromatList();
    }
    filterOnlyLowerText(value, search, item) {
        return value != null &&
            search != null &&
            typeof value === 'string' &&
            value.toString().toLocaleLowerCase().indexOf(search) !== -1;
    }
    setFilter(key, value) {
        this.clearFilterByKey(key);
        if (value != -1 || value != '-1') {
            this.filter.push({ key: key, value: value });
        }
    }
    clearFilterByKey(key) {
        for (let i = 0; i < this.filter.length; i++) {
            if (this.filter[i].key == key) {
                this.filter.splice(i, 1);
            }
        }
        return false;
    }
    watchOptions() {
        this.getFromatList();
        this.clear();
    }
    watchSearch() {
        this.getFromatList();
        this.clear();
    }
    watchItem() {
        this.getFromatList();
    }
    mounted() {
        if (this.$store.getters.isLoggedIn) {
            this.getFromatList();
            this.$store.state.monitor = false;
        }
        else {
            this.$store.commit('logout');
        }
    }
};
__decorate([
    Watch('options', { deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], FormatList.prototype, "watchOptions", null);
__decorate([
    Watch('search'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], FormatList.prototype, "watchSearch", null);
__decorate([
    Watch('item', { deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], FormatList.prototype, "watchItem", null);
FormatList = __decorate([
    Component({
        name: "FormatList",
    })
], FormatList);
export default FormatList;
